import React from "react"
import headStyle from "./Heading.module.css"

function Heading(props) {
  return (
    <div className={headStyle.heading}>
      <h4 className={headStyle.headingElement}>{props.headingTxt}</h4>
      <h4 className={headStyle.headingElement}>{props.headingTxt}</h4>
    </div>
  )
}

export default Heading
